import React, { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Select, Space, Spinner } from "@masterteam/mt-design-react";

import EmptyData from "../../EmptyData";
import ObjectiveCard from "../ObjectiveCard";

import api from "../../../providers/api";
import { addToast } from "../../../helpers";
import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

const ObjectivesList = ({ statuses, selectedStrategy }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const [data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [selectedPerspective, setSelectedPerspective] = useState(null);

  const getData = async () => {
    setDataLoading(true);
    try {
      const res = await api.kpiDashboard.getDataByPerspectiveId(
        selectedStrategy?.ID,
        { priority: selectedPerspective?.ID }
      );

      setData(res.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [selectedPerspective]);

  return (
    <Space gap={16} direction="vertical" className="objectives-list-wrapper">
      <Row className="title-wrapper">
        <h2>{intl.formatMessage({ id: "common.strategic-objectives" })}</h2>
      </Row>

      <Space align="center" className="perspective-select-wrapper">
        <FormattedMessage id="common.perspective" />

        <div className="select">
          <Select
            value={selectedPerspective}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(e) => setSelectedPerspective(e)}
            placeholder={intl.formatMessage({ id: "common.perspective" })}
            // isLoading={isLoading}
            isClearable={true}
            options={selectedStrategy?.Perspectives}
          />
        </div>
      </Space>

      {dataLoading ? (
        <Row justify="center" style={{ marginTop: "24px" }}>
          <Spinner size="large" />
        </Row>
      ) : data?.length > 0 ? (
        <div
          className={`objectives-list-content animated ${
            isAr ? "fadeInLeft" : "fadeInRight"
          }`}
        >
          {data.map((item) => (
            <ObjectiveCard key={item?.ID} data={item} statuses={statuses} />
          ))}
        </div>
      ) : (
        <EmptyData title={<FormattedMessage id="no-data" />} />
      )}
    </Space>
  );
};

export default ObjectivesList;
